/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/ScheduleViaSMSOrEmail/Content/ScheduleViaDialog/Content/Content/Content/CustomInstructions/Content",
  onChange,
  invalid
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let scheduleViaCustomInstructionsValueData = fromData.useDataValue({ viewPath,
context: 'schedule_via',
path: 'custom_instructions',
})
let scheduleViaCustomInstructionsChangeData = fromData.useDataChange({ viewPath,
context: 'schedule_via',
path: 'custom_instructions',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={dtSpaceM}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Custom instructions"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 placeholder="Enter additional instructions for the patient here"
 data="schedule_via.custom_instructions"
 value={scheduleViaCustomInstructionsValueData}
 onChange={scheduleViaCustomInstructionsChangeData}
 invalid={invalid}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 size="tiny"
 text="Along with the instructions, the patient will also receive a link to schedule the appointment."
/>
{children}
</React.Fragment>)
}